<div class="dialog-content-max">
    
    <form [formGroup]="departmentform">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="departmentname" class="required-label">Department Name<span class="maxchars">(Max 50 chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="departmentname" name="departmentname" formControlName="departmentname"
                placeholder="Enter Department name">
                <span class="errormessage" *ngIf="departmentform.get('departmentname').invalid && (departmentform.get('departmentname').dirty || departmentform.get('departmentname').touched)">
                    {{getErrorMessage(departmentform ,validation_message,'departmentname')}}
                </span>  
            </div>
        </div>
        
     <div class="formgrid grid">
        <div class="field col-12">
            <label for="deptinitial" class="required-label">Department Initial<span class="maxchars">(Max 20 chars)</span><span>*</span></label>
            <input type="text" class="form-control" id="deptinitial" inputId="deptinitial" name="deptinitial" formControlName="deptinitial" placeholder="Enter Department initial">
            <span class="errormessage" *ngIf="departmentform.get('deptinitial').invalid && (departmentform.get('deptinitial').touched || departmentform.get('deptinitial').dirty )">
                {{ getErrorMessage(departmentform, validation_message, 'deptinitial') }}
            </span>  
        </div>
     </div>
        
     <div class="formgrid grid" *ngIf="isEdit">
        <div class="field col-12" >
            <label for="activeflag" class="required-label">Active Flag<span>*</span></label>
            <p-dropdown [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body" name="activeflag"
                optionLabel="labelname" optionValue="value" placeholder="Select Flag" formControlName="activeflag"></p-dropdown>

            <span class="errormessage" *ngIf="departmentform.get('activeflag').invalid && departmentform.get('activeflag').touched">
                {{ getErrorMessage(departmentform, validation_message, 'activeflag') }}
            </span>    
        </div>
     </div>
        
    </form>
    
    <div class="custom-dialog-footer">
        <!-- <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button> -->
        <p-button class="m-1" label="Close" styleClass="customeclose" (click)="closemodal(departmentform,this.ref,'Are you sure you want to close?')"></p-button>

        <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave" 
            (click)="addDepartment()">
        </p-button>
    </div>

</div>
